import React, {
  Fragment,
  lazy,
  Suspense,
  useReducer,
  useEffect,
  useMemo,
  createContext,
} from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { ToastProvider } from "react-toast-notifications";
import { LoadingComponent } from "../../components/Loaders/mainLoader";
import RateContainer from "./ratesContext";
import ResetContainer from "./resetPassword";
import CurrentStoreDetails from "./storeContext";
import ClientApollo from "../graphql";
import Auth from "../cookie.config";
// import HandleNotFound from "../../pages/NotFound";

const LoginComponent = lazy(() => import("../../pages/Auth/login"));
const LayoutComponent = lazy(() => import("../../components/layout"));
const ForgotPasswordComponent = lazy(
  () => import("../../pages/Auth/forgotPassword")
);
const VerifyComponent = lazy(() => import("../../pages/Auth/verifyPage"));

interface ContextState {
  isLoading: boolean;
  isSignout: boolean;
  userToken: object;
}

interface authContextControllerProps {
  signIn: Function;
  signOut: Function;
}

export const AuthContext = createContext(
  [] as (ContextState | authContextControllerProps | any)[]
);

const Manipulator = (prevState: any, action: any) => {
  switch (action.type) {
    case "RESTORE_TOKEN":
      return {
        ...prevState,
        userToken: action.userToken,
        isLoading: false,
      };
    case "SIGN_IN":
      return {
        ...prevState,
        isSignout: false,
        userToken: action.token,
      };
    case "SIGN_OUT":
      return {
        ...prevState,
        isLoading: false,
        userToken: null,
        isSignout: true,
      };
    default:
      return prevState;
  }
};

const SettingsConfig = ({ state }: any) => {
  return (
    <Fragment>
      <BrowserRouter>
        <Suspense fallback={LoadingComponent()}>
          <ToastProvider autoDismiss>
            <Switch>
              <Route component={LoginComponent} path={"/login"} exact={true} />
              <Route
                component={ForgotPasswordComponent}
                path={"/forgot-password"}
                exact={true}
              />
              <Route
                component={VerifyComponent}
                path={"/verification"}
                exact={true}
              />
              {/* <Route
                component={HandleNotFound}
                path={"/not-found"}
                exact={true}
              /> */}
              <Route component={LayoutComponent} path={"/"} />
            </Switch>
          </ToastProvider>
        </Suspense>
      </BrowserRouter>
    </Fragment>
  );
};

function AppNavigator() {
  const [state, dispatch] = useReducer(Manipulator, {
    isLoading: true,
    isSignout: false,
    userToken: null,
  });

  useEffect(() => {
    let userToken: string | null = Auth.getCipher();
    let data;
    if (userToken) data = JSON.parse(userToken);
    else data = null;
    dispatch({ type: "RESTORE_TOKEN", userToken: data });
  }, []);

  const authContextController = useMemo(
    () => ({
      signIn: async (token: object): Promise<void> => {
        Auth.setCipher(JSON.stringify(token));
        dispatch({ type: "SIGN_IN", token: token });
      },
      signOut: (): void => {
        Auth.clearCipher();
        dispatch({ type: "SIGN_OUT" });
      },
    }),
    []
  );
  return (
    <Fragment>
      {state.isLoading ? (
        <LoadingComponent />
      ) : (
        <Fragment>
          <AuthContext.Provider value={[authContextController, state]}>
            <ClientApollo>
              <RateContainer>
                <CurrentStoreDetails>
                  <ResetContainer>
                    <SettingsConfig state={state} />
                  </ResetContainer>
                </CurrentStoreDetails>
              </RateContainer>
            </ClientApollo>
          </AuthContext.Provider>
        </Fragment>
      )}
    </Fragment>
  );
}

export default AppNavigator;
